import { useEffect, useCallback } from 'react';
import { negativeStatus } from 'interface/course';
import { useAppSelector } from 'hooks/redux';
import { socket } from 'services/socket';
import { sendElastic } from 'actionCreators/judasLog';
import { useParams } from 'react-router';

export const useEmitLessonMessages = () => {
  const { courseHash } = useParams<{ courseHash: string }>();
  const courseStatus = useAppSelector((state) => state.course.status);
  const courseTitle = useAppSelector((state) => state.course.title);
  const courseId = useAppSelector((state) => state.newLesson.lesson?.id_course);
  const lessonId = useAppSelector((state) => state.newLesson.lesson?.id);
  const lessonTitle = useAppSelector((state) => state.newLesson.lesson?.title);
  const lessonStatus = useAppSelector((state) => state.newLesson.lesson?.status);
  const userId = useAppSelector((state) => state.user.id);

  const emitPageInOut = useCallback(
    (title: 'page-in' | 'page-out') => {
      if (!userId) return;
      socket.emit(title, {
        context: 'learner',
        page: 'lesson-page',
        userId,
      });
    },
    [userId]
  );

  const emitLessonPageInOut = useCallback(
    (title: 'lesson-page-in' | 'lesson-page-out') => {
      if (!userId || !lessonId) return;
      socket.emit(title, {
        context: 'learner',
        userId,
        courseId,
        lessonId,
      });
    },
    [userId, courseId, lessonId]
  );

  const sendMessage = useCallback(() => {
    if (!userId || !lessonId) return;
    const blocked = negativeStatus.includes(lessonStatus) ? 'bloqueado(a)' : '';
    const message = `Visualizou a aula ${lessonTitle} do curso ${courseTitle} ${blocked}`;
    sendElastic('viewLesson', message, {
      courseHash,
      courseId,
      lessonId,
      status: courseStatus,
    });
  }, [userId, courseId, lessonId, lessonStatus, lessonTitle, courseHash, courseStatus, courseTitle]);

  useEffect(() => {
    sendMessage();
  }, [sendMessage]);

  useEffect(() => {
    emitLessonPageInOut('lesson-page-in');
    return () => {
      emitLessonPageInOut('lesson-page-out');
    };
  }, [emitLessonPageInOut]);

  useEffect(() => {
    emitPageInOut('page-in');
    return () => {
      emitPageInOut('page-out');
    };
  }, [emitPageInOut]);
};
